import { createSelector } from '@reduxjs/toolkit'

export const selectedCurrencySelector = createSelector(
  (state: AppState) => state.currency.selectedCurrency,
  (value) => value
)

export const currencyRatesSelector = createSelector(
  (state: AppState) => state.currency.currencyRates,
  (value) => value
)
